import React, { useEffect, useState } from "react";
import { StyleSheet, View, Animated } from "react-native";

//Custom Imports
import color from "@constants/color";
import t from "@constants/localization";
import CustomText from "@components/CustomText";
import ContestProgressItem from "./ContestProgressItem";

const PATH = "screens/Contest/contestDetails";

const JourneyProgress = ({
  item = {},
  tl_image = "",
  tl_name = "",
  journeyVisible = false,
  language = "",
}) => {
  const {
    current_slab_index = 0,
    formatted_slabs = [],
    actual_slab_count = 0,
    contest_ended = false,
  } = item;

  const [height, setHeight] = useState(0);
  const progressAnim = new Animated.Value(0);

  useEffect(() => {
    journeyVisible && onCurrentPositionChanged(current_slab_index);
  }, [height, journeyVisible]);

  const onCurrentPositionChanged = (position) => {
    const progressLength = formatted_slabs.length - 1 ?? 1;
    let animateToPosition = (height / progressLength) * (position + 1);
    if (actual_slab_count === current_slab_index) {
      animateToPosition = animateToPosition - 30;
    }

    Animated.sequence([
      Animated.timing(progressAnim, {
        toValue: animateToPosition,
        duration: 2000,
        useNativeDriver: false,
      }),
    ]).start();
  };

  const renderProgressItem = (item, index, array) => {
    if (item) {
      return (
        <ContestProgressItem
          key={index}
          item={item}
          index={index}
          array={array}
          current_slab_index={current_slab_index}
          tl_image={tl_image}
          tl_name={tl_name}
          contest_ended={contest_ended}
          language={language}
        />
      );
    } else return null;
  };

  const progressBarStyle = {
    backgroundColor: color.darkSkyBlue,
    position: "absolute",
    left: "53.5%",
    top: 4,
    bottom: 0,
    width: 6,
    height: progressAnim,
  };

  return (
    <View style={styles.container}>
      <CustomText
        variant="subtitle_16"
        newfont={true}
        numberOfLines={1}
        style={styles.titleText}
      >
        {t(`${PATH}/yourJourney`)}
      </CustomText>
      <View
        onLayout={(event) => setHeight(event.nativeEvent.layout.height)}
        style={{ marginTop: 10 }}
      >
        <View style={styles.progressBarBackgroundStyle} />
        <Animated.View style={progressBarStyle} />
        {formatted_slabs.map(renderProgressItem)}
      </View>
    </View>
  );
};

export default JourneyProgress;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    paddingHorizontal: 16,
    marginTop: 24,
  },
  titleText: {
    color: color.mediumBlack,
  },
  centralAlignment: {
    justifyContent: "center",
    alignItems: "center",
  },
  row: {
    flexDirection: "row",
  },
  infoContainerStyle: { marginVertical: 10 },
  leftDataView: { flex: 1 },
  rightDataView: {
    flex: 7,
    paddingLeft: 5,
    paddingBottom: 10,
  },
  progressBarBackgroundStyle: {
    backgroundColor: color.color_D9D9D9,
    position: "absolute",
    left: "53.5%",
    top: 4,
    bottom: 20,
    width: 6,
  },
});
